<template>
  <pie-chart :chartData="chartData" :options="chartOptions"></pie-chart>
</template>

<script>
import colors from "vuetify/lib/util/colors";
import _ from "lodash";
import PieChart from "@/PieChart";

export default {
  components: { PieChart },
  props: {
    title: { type: String },
    orders: { type: Array },
    filter: { type: Array },
    field: { type: String },
    orderField: { type: String },
    elementField: { type: String },
  },
  data: () => {
    return {
      next: 0,
      chartOptions: {
        maintainAspectRatio: false,
        tooltips: {
          enabled: true,
          callbacks: {
            label: (tooltipItem, data) => {
              return (
                data.labels[tooltipItem.index] +
                ": " +
                data.datasets[tooltipItem.datasetIndex].data[
                  tooltipItem.index
                ] +
                " %"
              );
            },
          },
        },
      },
    };
  },
  computed: {
    ordersByFilter() {
      return _.chain(this.orders).groupBy(this.orderField).value();
    },
    chartData() {
      let data = [];
      let labels = [];
      let colors = [];
      let dataset = [];
      Object.entries(this.ordersByFilter).forEach(([filter, value]) => {
        let filterName = this.getElementByUuid(filter, this.filter, this.field)
          .label;
        dataset.push({
          data: Math.round((value.length / this.orders.length) * 100),
          label: filterName,
        });
      });
      dataset.sort((a, b) => (a.data > b.data ? 1 : b.data > a.data ? -1 : 0));
      for (let index in dataset) {
        labels.push(dataset[index].label);
        colors.push(this.getRandomColor());
        data.push(dataset[index].data);
      }
      this.resetColor();
      return {
        labels: labels,
        datasets: [{ label: "Orders", data: data, backgroundColor: colors }],
      };
    },
  },
  methods: {
    getElementByUuid(uuid, list, field) {
      let found = list.find((element) => element[this.elementField] == uuid);
      return found ? { label: found[field] } : { label: "unknown" };
    },
    getRandomColor() {
      let reds = Object.values(colors.red).slice(0, 3).reverse();
      let oranges = Object.values(colors.deepOrange).slice(0, 3).reverse();
      let yellows = Object.values(colors.yellow).slice(0, 3).reverse();
      let blueGreys = Object.values(colors.blueGrey).slice(0, 3).reverse();
      let greens = Object.values(colors.green).slice(0, 3).reverse();
      let vuetifyColors = reds
        .concat(oranges)
        .concat(yellows)
        .concat(blueGreys)
        .concat(greens);
      let color = vuetifyColors[this.next];
      this.next += 1;
      return color;
    },
    resetColor() {
      this.next = 0;
    },
  },
};
</script>
